import { atom } from 'jotai';

export const chartAtom = atom([
    {
      SiteUID: 0,
      Time: {},
      AvgPower: [],
      AvgRPMMax: [],
      Interval: "Hour",
    }
  ]);